/**
 * Source https://github.com/alice-gothberg/mixitup-url-demo/blob/main/js/filters.ts
 */

import mixitup from '../wwwroot/js/Mixitup/mixitup.min.js'
import mixitupPagination from '../wwwroot/js/Mixitup/mixitup-pagination.min.js'
import mixitupMultiFilter from '../wwwroot/js/Mixitup/mixitup-multifilter.min.js'

/**
 * Interface for object to store active filter data
 */
interface QueryStringObject {
    page?: number
    tag?: string
}

/**
 * Create an instance of QueryStringObject from a search-string (URI)
 * @param str a search string, e.g. 'orderby=default&color=red&page=2'
 * @returns an instance of QueryStringObject
 */
const createQueryObjectFromString = (str: string): QueryStringObject => {
    let query: QueryStringObject = {
        page: 1,
        tag: ''
    }

    /**
     * Divide input string into filter property groups, populate
     * query object with data from input string.
     */
    let splitString = str.split("&")
    splitString.forEach((s) => {
        if (s.includes("page")) query.page = parseInt(s.split("=")[1])
        if (s.includes("tag")) query.tag = s.split('=')[1]
    })

    return query
}

/**
 * Create a search string from an object
 * @param query an instance of QueryStringObject
 * @returns a search string
 */
const createSearchString = (query: QueryStringObject): string => {
    let str = ""

    str += query.page > 0 ? "page=" + query.page : 1
    str += query.tag != "" ? "&tag=" + query.tag : ""

    return str
}

/**
 * Update search string to reflect current active filters
 */
const updateSearchString = () => {
    let activePage = document.querySelector('.mixitup-page.mixitup-page-active')
    let currentPage = activePage ? parseInt(activePage.getAttribute('data-page')) : 1

    let activeTags = document.querySelectorAll(".filter-control--tag.mixitup-control-active")
    let tagString = ""

    if (activeTags.length > 0) {
        activeTags.forEach((tag) => {
            tagString += tag.getAttribute("data-label-clean") + ","
        })
    }

    let queryObject: QueryStringObject = {
        page: currentPage,
        tag: tagString.replace(/,$/, ""),
    }

    let searchString = createSearchString(queryObject)
    window.history.replaceState({}, "", "?" + searchString)
}

/**
 * Activate/set filters. Called on page load
 * Creates an object from the current search string in the URL and
 * uses Mixitup Mulitifilter API to activate filters
 * @param mixer an instance of Mixitup
 */
const activateFilters = (mixer: any) => {
    if (window.location.search.length > 1) {
        let initialQuery: QueryStringObject = createQueryObjectFromString(
            window.location.search
        )

        if (mixer != null) {
            let tagQueryArrr = initialQuery.tag.split(',')
            let tagSelectorArr = []

            if (tagQueryArrr[0].trim() != '') {
                tagQueryArrr.forEach(tag => {
                    tagSelectorArr.push('[data-tag~=' + tag + ']')
                })
            }

            mixer.setFilterGroupSelectors('tag', tagSelectorArr)

            // Parse filter groups
            mixer.parseFilterGroups()

            // Paginate
            let currentPage = initialQuery.page > 0 ? initialQuery.page : 1
            mixer.paginate(currentPage)
        }
    }
}

const mixEndFunction = (state: any) => {
    updateSearchString()

    const hideOnFilterAll = document.querySelectorAll('.hide-on-filter-all') as NodeListOf<HTMLElement>
    const activeSelector = state.activeFilter.selector

    if (hideOnFilterAll.length > 0) {
        hideOnFilterAll.forEach(item => {
            const itemTags = item.getAttribute('data-tag').trim().split(' ')
            let showItem = false

            if (activeSelector == '.mix') {
                showItem = false
            }

            if (itemTags.length > 0) {
                itemTags.forEach(tag => {
                    if (activeSelector.includes(tag)) {
                        showItem = true
                    }
                })
            }

            if (!showItem) {
                item.style.display = 'none'
            } else {
                item.style.display = 'inline-block'
            }
        })
    }

    const highlightItem = document.querySelector('.microsite-flow__highlight') as HTMLElement

    if (highlightItem && activeSelector != '.mix') {
        highlightItem.style.display = 'none'
    } 
    else if (highlightItem) {
        highlightItem.style.display = 'block'
    }

    //TODO aria live notification
}


export default function initFilters() {
    const mixContainer = document.querySelector(".mix-container")
    
    mixitup.use(mixitupPagination)
    mixitup.use(mixitupMultiFilter)

    /**
     * Initialise mixer
     */
    let mixer
    if (mixContainer) {
        mixer = mixitup(mixContainer, {
            selectors: {
                target: ".mix",
            },
            animation: {
                enable: false
            },
            classNames: {
                elementPager: 'page'
            },
            pagination: {
                limit: 12,
                hidePageListIfSinglePage: true
            },
            callbacks: {
                onMixEnd: function(state) {
                    mixEndFunction(state)
                },
            },
            multifilter: {
                enable: true,
            },
            templates: {
                pager: '<button type="button" class="${classNames}" data-page="${pageNumber}" aria-label="Gå till sida ${pageNumber}">${pageNumber}</button>',
                pagerPrev: '<button type="button" class="${classNames}" data-page="prev" aria-label="Föregående sida"><svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.32783 6.49999L8.27783 11.45L6.86383 12.864L0.499832 6.49999L6.86383 0.135986L8.27783 1.54999L3.32783 6.49999Z" fill="black"/></svg></button>',
                pagerNext: '<button type="button" class="${classNames}" data-page="next" aria-label="Nästa sida"><svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.67217 6.50001L0.722168 1.55001L2.13617 0.136013L8.50017 6.50001L2.13617 12.864L0.722168 11.45L5.67217 6.50001Z" fill="black"/></svg></button>'
            }
        })
    }

    /**
     * Set filters on load
     */
    activateFilters(mixer)

    // Set active class on "all" if no active filters
    if (!document.querySelector('.mixitup-control-active'))
    {
        document.querySelector('.filter-control--show-all').classList.add('mixitup-control-active')
    }
}